export function formatHourToHHMM(timeString) {
	if (!timeString) return "";
	const [hours, minutes] = timeString.split(":");
	return `${hours}:${minutes}`;
}
